import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import AuswahlHinrichtungAusVorherigen from "./LinienführungHinrichtungVorherige";
import AuswahlHinrichtungNeueInfrastruktur from "./LinienführungHinrichtungNeu";
import RückrichtungAnalog from "./LinienführungRückrichtungAnalog";
import AuswahlRückrichtungAusVorherigen from "./LinienführungRückrichtungVorherige";
import AuswahlRückrichtungNeueInfrastruktur from "./LinienführungRückrichtungNeu";
import { FehlerauswertungErrResp } from "../../Fehler/FehlerauswertungErrResp";

var MonitorApi = require('monitor-api');

export default function NeueLinienführung({ strVerlInstance, linienInstance, linienVerlInstance, bhfInstance, strInstance }) {
    const [linienListe, setLinienListe] = useState([]);
    const [previousVerlaeufe, setPreviousVerlaeufe] = useState([]);
    const [test, setTest] = useState({});
    const [linieId, setLinieId] = useState();
    const [bhfListe, setBhfListe] = useState();

    const navigate = useNavigate();

    const [hrCollection, setHrCollection] = useState({
        hrStreckenId: undefined,
        hrHalte: {},
        hrVerlauf: [],
        mirrored: undefined,
        bisherigeStrNutzen: false,
        neueStrecke: false,
    });

    const [rrCollection, setRrCollection] = useState({
        rrStreckenId: undefined,
        rrHalte: {},
        rrVerlauf: [],
        mirrored: undefined,
        rrAnalog: false,
        bisherigeStrNutzen: false,
        neueStrecke: false
    })

    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();

    function refreshBothCollections() {
        setHrCollection({
            ...hrCollection,
            hrStreckenId: undefined,
            hrVerlauf: [],
            hrHalte: {},
            mirrored: undefined,
            neueStrecke: false,
            bisherigeStrNutzen: false
        });
        setRrCollection({
            ...rrCollection,
            rrHalte: {},
            rrVerlauf: [],
            rrStreckenId: undefined,
            mirrored: undefined,
            bisherigeStrNutzen: false,
            rrAnalog: false,
            neueStrecke: false
        });
    }

    const loadPreviousVerlaeufe = (instance, id_linie) => {
        refreshBothCollections();
        instance.getLinienverlaufLinienverlaufIdLinieGet(id_linie, (error, data) => {
            if (error) {
                console.log(error);
            } else {
                console.log(">>vorherige Linienverläufe laden");
                console.log(data);
                data.forEach(element => {
                    if (element.gueltig_von) {
                        element.gueltig_von = element.gueltig_von.toLocaleDateString();
                    }
                    if (element.gueltig_bis) {
                        element.gueltig_bis = element.gueltig_bis.toLocaleDateString();
                    }
                });
                setPreviousVerlaeufe(data);
            }
        })

        instance.getLinienverlaufCombined(id_linie, (error, data) => {
            if (error) {
                console.log(error);
            } else {
                console.log(">>vorherige Linienverläufe laden");
                data.infrasHin.forEach(element => {
                    if (element.gueltig_von) {
                        element.gueltig_von = element.gueltig_von.toLocaleDateString();
                    }
                    if (element.gueltig_bis) {
                        element.gueltig_bis = element.gueltig_bis.toLocaleDateString();
                    }
                })
                data.infrasRueck.forEach(element => {
                    if (element.gueltig_von) {
                        element.gueltig_von = element.gueltig_von.toLocaleDateString();
                    }
                    if (element.gueltig_bis) {
                        element.gueltig_bis = element.gueltig_bis.toLocaleDateString();
                    }
                })

                setTest(data);
            }
        })
    }

    useEffect(() => {
        const loadLinien = (instanceL) => {
            instanceL.getListedLinienLinienlisteGet((error, data) => {
                if (error) {
                    console.log(error);
                } else {
                    console.log('>>load linienliste');
                    setLinienListe(data);
                }
            })
        }

        const loadBhf = (instanceB) => {
            instanceB.getListOfBahnhofsBahnhoflisteGet((error, data) => {
                if (error) {
                    console.log(error);
                } else {
                    console.log('>>load bhfListe');
                    setBhfListe(data);
                }
            })
        }

        loadLinien(linienInstance);
        loadBhf(bhfInstance);
    }, [linienInstance, setLinienListe, bhfInstance, setBhfListe])

    const selectLinie = event => {
        setLinieId(event.target.value);
        loadPreviousVerlaeufe(linienVerlInstance, parseInt(event.target.value));
    }

    function tinkerObjectToSave(hrInformation, rrInformation, start, end) {
        const toSave = new MonitorApi.CreateLinienverlauf();
        toSave.linieId = linieId;
        toSave.id_strecke_hr = hrInformation.hrStreckenId;
        toSave.id_strecke_rr = rrInformation.rrStreckenId;
        toSave.halt_hr = Object.keys(hrInformation.hrHalte).filter(it => hrInformation.hrHalte[it]).map(it => parseInt(it));
        toSave.halt_rr = Object.keys(rrInformation.rrHalte).filter(it => rrInformation.rrHalte[it]).map(it => parseInt(it));
        toSave.verlauf_hr = hrInformation.hrVerlauf.filter(it => it.verlauf).map(item => item.id_bhf);
        toSave.verlauf_rr = rrInformation.rrVerlauf.filter(it => it.verlauf).map(item => item.id_bhf);
        toSave.mirrored_hr = hrInformation.mirrored;
        toSave.mirrored_rr = rrInformation.mirrored;
        toSave.gueltig_von = start;
        if (end) {
            toSave.gueltig_bis = end;
        }
        console.log("zu speichern: ", toSave);

        return toSave;
    }

    const saveNewDirections = (event) => {
        event.preventDefault();
        const toSave = tinkerObjectToSave(hrCollection, rrCollection, startDate, endDate);
        linienVerlInstance.createNewLinienverlauf(toSave, (error, data, response) => {
            if (error) {
                FehlerauswertungErrResp(error, response);
            } else {
                alert("Für " + data.name + " ist neuer Verlauf angelegt.");
                navigate(`../linienfuehrung`, { replace: true });
            }
        })
    }

    return (
        <div>
            <h3 className="ls-h3">Anlegen einer neuen Linienführung</h3>
            {/* <p>{JSON.stringify(hrCollection)}</p>
            <p>{JSON.stringify(rrCollection)}</p> */}
            <section>
                <label>Linie: <select onChange={selectLinie}>
                    <option hidden>---Linie wählen---</option>
                    {linienListe.map(linie => <option key={linie.id} value={linie.id}>{linie.linie}</option>)}
                </select></label>

                {linieId && <section>
                    {/* <p>{JSON.stringify(test)}</p> */}
                    <p>{JSON.stringify(hrCollection)}</p>
                    <h4>Hinrichtung:</h4>
                    {/* <p>Halte:</p>
                    <p>{JSON.stringify(hrCollection.hrHalte)}</p>
                    <p>Verlauf:</p>
                    <p>{JSON.stringify(hrCollection.hrVerlauf)}</p> */}

                    <AuswahlHinrichtungAusVorherigen
                        previousVerlaeufe={previousVerlaeufe}
                        previousHin={test.infrasHin}
                        hrCollection={hrCollection}
                        setHrCollection={setHrCollection}
                    />

                    <AuswahlHinrichtungNeueInfrastruktur
                        hrCollection={hrCollection}
                        setHrCollection={setHrCollection}
                        bhfListe={bhfListe}
                        strInstance={strInstance}
                        strVerlInstance={strVerlInstance}
                    />

                    {hrCollection.hrStreckenId && <>
                        <p>{JSON.stringify(rrCollection)}</p>

                        <h4>Rückrichtung:</h4>
                        <RückrichtungAnalog
                            hrCollection={hrCollection}
                            rrCollection={rrCollection}
                            setRrCollection={setRrCollection}
                        />

                        <AuswahlRückrichtungAusVorherigen
                            previousVerlaeufe={previousVerlaeufe}
                            previousRueck={test.infrasRueck}
                            rrCollection={rrCollection}
                            setRrCollection={setRrCollection}
                        />

                        <AuswahlRückrichtungNeueInfrastruktur
                            rrCollection={rrCollection}
                            setRrCollection={setRrCollection}
                            bhfListe={bhfListe}
                            strInstance={strInstance}
                            strVerlInstance={strVerlInstance} />

                    </>}

                    {hrCollection.hrStreckenId && rrCollection.rrStreckenId &&
                        <>
                            <div>
                                <h4>Gültig ab dem:</h4>
                                <input type="date" onChange={(e) => setStartDate(e.target.value)}></input>
                            </div>
                            <br></br>
                            <div>
                                <h4>Gültig bis (optional):</h4>
                                <input type="date" min={startDate} onChange={(e) => setEndDate(e.target.value)}></input>
                            </div>
                            <br></br>
                            <div>
                                <button
                                    disabled={!(hrCollection.hrStreckenId && rrCollection.rrStreckenId && startDate)}
                                    onClick={saveNewDirections}
                                >Verlauf anlegen</button>
                            </div>
                        </>
                    }
                </section>}
            </section>


            <h4 style={{ color: "red", marginBottom: "0" }}>getroffene Auswahl*:</h4>
            <p style={{ marginLeft: "1em", color: "red", fontSize: "small", marginTop: "0" }}>*Später wird diese Anzeige durch "Speichern"-Button ersetzt.</p>
            <p>Linie: {linieId}</p>
            <section className="anzeige">
                <div>
                    <label>Hinrichtung:</label>
                    <p>ID: {hrCollection.hrStreckenId}</p>
                    <p>Verlaufsbeschreibung: {JSON.stringify(hrCollection.hrVerlauf.map(item => item.id_bhf))}</p>
                    <p>Halte: {JSON.stringify(Object.keys(hrCollection.hrHalte))}</p>
                    <p>mirrored: {JSON.stringify(hrCollection.mirrored)}</p>
                </div>
                <div>
                    <label>Rückrichtung:</label>
                    <p>ID: {rrCollection.rrStreckenId}</p>
                    <p>Verlaufsbeschreibung: {JSON.stringify(rrCollection.rrVerlauf.map(item => item.id_bhf))}</p>
                    <p>Halte: {JSON.stringify(Object.keys(rrCollection.rrHalte))}</p>
                    <p>mirrored: {JSON.stringify(rrCollection.mirrored)}</p>
                </div>
            </section>
        </div>
    )
}


